import { gql } from "apollo-angular";

export const LIST_ARPY_REQUIREMENT_FILES_QUERY = gql`query arpyListRequirementFiles($sourceType: ArpyRequirementSourceType) {
    arpyListRequirementFiles(sourceType: $sourceType) {
      success
      message
      data {
        id
        fileName
        baseFileName
        version
        isLatest
        fileSize
        contentHash
        s3Key
        description
        sourceType
        createdAt
        createdBy
        updatedAt
        isActive
      }
    }
  }
  `

export const GET_ARPY_REQUIREMENT_FILE_QUERY = gql`query arpyGetRequirementFile($id: ID!) {
    arpyGetRequirementFile(id: $id) {
      success
      message
      data {
        id
        fileName
        baseFileName
        version
        isLatest
        fileSize
        contentHash
        s3Key
        description
        sourceType
        createdAt
        createdBy
        updatedAt
        isActive
      }
    }
  }
  `

export const GET_ARPY_DOWNLOAD_URL_MUTATION = gql`mutation arpyGetDownloadURL($id: ID!) {
    arpyGetDownloadURL(id: $id) {
      success
      message
      data {
        url
        expiresIn
      }
    }
  }
  `

// Vehicle functions, their sub-functions, and every requirement attached to
// either, parsed server-side from the latest TEESA.json - see
// ArpyApiService.getAllVehicleFunctions(). No id argument: always resolves
// against whichever TEESA.json is currently latest.
export const GET_ARPY_VEHICLE_FUNCTION_CATALOG_QUERY = gql`query arpyGetVehicleFunctionCatalog {
    arpyGetVehicleFunctionCatalog {
      success
      message
      data {
        vehicleFunctions {
          uid
          name
          description
          asil
          subFunctionUids
          requirementUids
        }
        vehicleSubFunctions {
          uid
          name
          nameIsDerived
          vehicleFunctionUid
          description
          asil
          requirementUids
        }
        requirements {
          uid
          name
          version
          description
          asil
          maturityLevel
          status
          vehicleFunctionUid
          vehicleSubFunctionUid
        }
        sourceFileVersion
      }
    }
  }
  `
